import React, { FC, useState, useEffect } from 'react';
import {
  Modal,
  ModalHeading,
  InputsSection,
  ModalButtons,
  ModalForm,
} from '../../components/Modal';
import styles from './SelectClinicianModal.module.css';

interface IClinician {
  _id: string;
  name: string;
}

interface SelectClinicianModalProps {
  show: boolean;
  onClose: () => void;
  onSelect: (clinicianId: string) => void;
  clinicians: IClinician[];
  currentClinicianId?: string;
}

const SelectClinicianModal: FC<SelectClinicianModalProps> = ({
  show,
  onClose,
  onSelect,
  clinicians,
  currentClinicianId,
}) => {
  const [selectedClinicianId, setSelectedClinicianId] = useState<string>(
    currentClinicianId || ''
  );
  
  const handleSelect = () => {
    if (selectedClinicianId) {
      onSelect(selectedClinicianId);
      onClose();
    }
  };

  if (!show) return null;

  return (
    <Modal show={show}>
      <ModalHeading heading="Select Account Owner" />
      <ModalForm>
        <InputsSection style={{ width: '34rem' }}>
          <div className={styles.clinicianList}>
            {clinicians.map((clinician) => (
              <div 
                key={clinician._id}
                className={`${styles.clinicianItem} ${
                  selectedClinicianId === clinician._id ? styles.selected : ''
                }`}
                onClick={() => setSelectedClinicianId(clinician._id)}
              >
                <div className={styles.radioContainer}>
                  <input
                    type="radio"
                    id={`clinician-${clinician._id}`}
                    name="clinician"
                    value={clinician._id}
                    checked={selectedClinicianId === clinician._id}
                    onChange={() => setSelectedClinicianId(clinician._id)}
                    className={styles.radioInput}
                  />
                  <label htmlFor={`clinician-${clinician._id}`} className={styles.clinicianLabel}>
                    {clinician.name}
                  </label>
                </div>
              </div>
            ))}
          </div>
        </InputsSection>
        
        <ModalButtons
       
          cancelButtonLabel="Cancel"
          submitButtonLabel="Update"
          onCancel={onClose}
          onSubmit={handleSelect}
          submitButtonDisabled={!selectedClinicianId}
        />
      </ModalForm>
    </Modal>
  );
};

export default SelectClinicianModal;
